import { useAcademiesStore } from "@/stores/academies";

/*
 * Llama a los métodos de carga indicados cuando la academia seleccionada está
 * disponible. Al recargar la página, el store de academias empieza con
 * academy.uuid vacío y lo rellena getAcademy() al arrancar: si una tarjeta pide
 * sus datos en mounted, envía academy_uuid vacío y la API responde 422.
 *
 * Mismo patrón que MenuComponent: en mounted si el uuid ya está y, si no, cuando
 * llega. También vuelve a cargar si cambia la academia seleccionada. Nunca carga
 * dos veces para la misma academia.
 *
 * Uso: mixins: [loadWhenAcademyReady('getColors')]
 */
export default function loadWhenAcademyReady(...methods) {
    return {
        data() {
            return {
                loadedAcademyUuid: null,
            }
        },
        computed: {
            selectedAcademyUuid() {
                return useAcademiesStore().academy.uuid
            },
        },
        watch: {
            selectedAcademyUuid() {
                this.loadForSelectedAcademy()
            },
        },
        mounted() {
            this.loadForSelectedAcademy()
        },
        methods: {
            loadForSelectedAcademy() {
                const uuid = this.selectedAcademyUuid

                if (!uuid || uuid === this.loadedAcademyUuid) {
                    return
                }

                this.loadedAcademyUuid = uuid
                methods.forEach((method) => this[method]())
            },
        },
    }
}
